module.exports = __webpack_public_path__ + "img/hug.3eb003e1.svg";